/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import { Typography, Card, Grid, Box } from "@mui/material";

import "./ServicesCards.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import { useScrollReveal } from "../../../../helpers/ScrollReveal";
import { useLanguageContext } from "../../../../context/languageContext";
import { textlanguages } from "../../../../data/textOfThePage";

export default function ServicesCardsForPage() {
  const { languageSelected } = useLanguageContext();

  useScrollReveal([
    {
      selector: ".revealFromCenterCards",
      options: {
        distance: "0px",
        duration: 1000,
        easing: "ease-out",
        origin: "center",
        reset: false,
      },
    },
  ]);
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "30px",
        justifyContent: "center",
      }}
    >
      {textlanguages[languageSelected].ourServices.tecnologyCards.map(
        (card) => (
          <Box key={card.title} sx={{ width: "350px" }}>
            <Card className="card-container">
              <Box className="card-icon-container" sx={{ mb: "40px" }}>
                <img
                  src={card.icon}
                  className="card-icon"
                  alt="Ícono diseño y desarrollo web"
                />
              </Box>
              <Typography variant="h5" className="card-title">
                {card.title}
              </Typography>
              <Typography variant="h6" className="card-description">
                {card.description}
              </Typography>
              <Grid container>
                {card.tecnologies.map((tecnology) => (
                  <Grid item xs={3} key={tecnology.name}>
                    <img
                      src={tecnology.icon}
                      className="technology-icon"
                      alt={`${tecnology.name} Logo`}
                    />
                  </Grid>
                ))}
              </Grid>
            </Card>
          </Box>
        )
      )}
    </Box>
  );
}
